import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebaseConfig";

const createStatId = httpsCallable(functions, "createStatId");

export const encryptPayload = async (payload) => {
  try {
    const response = await createStatId({ payload });
    const statid = response?.data?.statid;
    if (!statid) {
      throw new Error("Missing statid in cloud function response");
    }
    return statid;
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};

// export const decryptPayload = (encryptedString) => {
//   try {
//     if (!SECRET_KEY) {
//       throw new Error("Encryption key not configured");
//     }

//     const decodedString = decodeURIComponent(encryptedString);
//     const bytes = CryptoJS.AES.decrypt(decodedString, SECRET_KEY);
//     const decrypted = CryptoJS.enc.Base64.stringify(bytes);

//     if (!decrypted) {
//       throw new Error("Decryption failed - invalid key or data");
//     }

//     return JSON.parse(decrypted);
//   } catch (error) {
//     console.error("Decryption error:", error);
//     return null;
//   }
// };
